
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceindelhiforindutrial() {



    const cardData =
    {
        keyword: '  Corporate Cab Services in Delhi for Industrial',
        heading: 'etravo : Corporate Cab Services in Delhi for Industrial',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Delhi for Industrial zones, designed for factories, manufacturing units, warehouses, and logistics companies that require safe, punctual, and efficient employee transportation. With GPS-enabled vehicles, experienced chauffeurs, and flexible shift-based plans, eTravo ensures smooth workforce mobility, daily pickup and drop, and executive travel across Delhi’s major industrial areas.",

"top": "Top Industrial Areas in Delhi for Corporate Cab Services with eTravo",

"topPlaces": [
  {
    "title": "Okhla Industrial Area",
    "description": "One of Delhi’s major industrial hubs with factories, production units, and corporate offices requiring daily employee transport and shift-based cab services."
  },
  {
    "title": "Mayapuri Industrial Area",
    "description": "A large automotive and manufacturing hub where workforce transportation and logistics movement require reliable cab services."
  },
  {
    "title": "Wazirpur Industrial Area",
    "description": "A key industrial zone with steel, metal, and fabrication units requiring structured employee pickup and drop services."
  },
  {
    "title": "Naraina Industrial Area",
    "description": "A well-developed industrial belt with factories and corporate units needing daily workforce transportation solutions."
  },
  {
    "title": "Jhilmil Industrial Area",
    "description": "A growing industrial region in East Delhi with manufacturing and trading units requiring employee commute services."
  },
  {
    "title": "Bawana Industrial Area",
    "description": "One of the largest industrial clusters in Delhi, requiring large-scale employee transport and shift-based cab operations."
  },
  {
    "title": "Narela Industrial Area",
    "description": "A developing industrial hub with logistics and manufacturing companies requiring reliable workforce mobility."
  },
  {
    "title": "Badli Industrial Area",
    "description": "A key industrial zone in North Delhi with factories and warehouses requiring structured transport services."
  },
  {
    "title": "DSIDC Bawana Cluster",
    "description": "A major industrial development zone supporting MSMEs and factories with high demand for employee transport."
  },
  {
    "title": "Delhi–Haryana Industrial Corridor",
    "description": "A key logistics and industrial route connecting Delhi’s factories with NCR hubs, requiring efficient cab services for business travel."
  }
],


"services": [
{
"name": "Industrial Cab Service Delhi",
"description": "eTravo offers reliable industrial cab services in Delhi designed for factories and industrial areas. Our service ensures punctual pickups, comfortable rides, and efficient transport solutions for workforce and staff."
},
{
"name": "Corporate Cab Industrial Delhi",
"description": "Our corporate cab services for industrial areas in Delhi provide dependable transportation for businesses. eTravo ensures smooth travel for employees and executives with professional service."
},
{
"name": "Factory Employee Transport Delhi",
"description": "eTravo provides factory employee transport services in Delhi for safe and punctual workforce commuting. Our service ensures structured routes and reliable daily travel."
},
{
"name": "Industrial Area Taxi Delhi",
"description": "Our industrial area taxi services in Delhi offer quick and dependable transport for workers and professionals. eTravo ensures clean vehicles and timely service across industrial zones."
},
{
"name": "Company Cab Industrial Delhi",
"description": "eTravo provides company cab services in industrial areas of Delhi tailored for employee transport and business travel. Our service ensures reliability and smooth operations."
},
{
"name": "Staff Transport Industrial Delhi",
"description": "eTravo offers staff transport services in industrial Delhi designed for daily employee commuting. Our service ensures punctual pickups, safe rides, and efficient travel coordination."
},
{
"name": "Corporate Travel Industrial Delhi",
"description": "Our corporate travel services in industrial areas of Delhi provide reliable transportation for business needs. eTravo ensures smooth travel for executives and teams."
},
{
"name": "Factory Pickup Drop Delhi",
"description": "eTravo provides factory pickup and drop services in Delhi for efficient workforce mobility. Our service ensures timely scheduling and comfortable commuting for employees."
},
{
"name": "Industrial Workforce Transport Delhi",
"description": "eTravo offers industrial workforce transport services in Delhi for safe and structured commuting. Our service ensures reliable travel solutions for factory workers and staff."
},
{
"name": "Business Cab Industrial Delhi",
"description": "eTravo’s business cab services in industrial Delhi are ideal for meetings, site visits, and corporate activities. Our service ensures punctual and professional travel experiences."
},
{
"name": "Plant Transport Cab Delhi",
"description": "eTravo provides plant transport cab services in Delhi for factory and industrial operations. Our service ensures safe and timely travel for workers and management."
},
{
"name": "Industrial Taxi Service Delhi",
"description": "Our industrial taxi services in Delhi are designed for reliable and efficient transportation. eTravo ensures smooth travel for employees and professionals across industrial zones."
},
{
"name": "Corporate Fleet Industrial Delhi",
"description": "eTravo offers corporate fleet services in industrial areas of Delhi for businesses requiring multiple vehicles. Our fleet ensures consistent quality and smooth operations."
},
{
"name": "Employee Commute Industrial Delhi",
"description": "eTravo’s employee commute services in industrial Delhi provide structured and dependable transportation. Our service ensures smooth daily travel for workforce mobility."
},
{
"name": "Office Cab Industrial Delhi",
"description": "eTravo provides office cab services in industrial Delhi for reliable employee commuting. Our service ensures punctual pickups and comfortable travel for daily office needs."
}
],
"tableData": [
["Industrial Cab Service Delhi", "Corporate Cab Industrial Delhi"],
["Factory Employee Transport Delhi", "Industrial Area Taxi Delhi"],
["Company Cab Industrial Delhi", "Staff Transport Industrial Delhi"],
["Corporate Travel Industrial Delhi", "Factory Pickup Drop Delhi"],
["Industrial Workforce Transport Delhi", "Business Cab Industrial Delhi"],
["Plant Transport Cab Delhi", "Industrial Taxi Service Delhi"],
["Corporate Fleet Industrial Delhi", "Employee Commute Industrial Delhi"],
["Office Cab Industrial Delhi", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Specialized Corporate Cab Services for Industrial Areas in Delhi",
      "WhyChoosedescription": "eTravo offers dedicated corporate cab services in Delhi for industrial zones, ensuring smooth and efficient employee transportation for factories, warehouses, and manufacturing units across areas like Okhla, Bawana, and Narela."
    },
    {
      "WhyChooseheading": "Ideal for Manufacturing and Industrial Workforce",
      "WhyChoosedescription": "Industrial areas in Delhi require structured transport solutions for shift-based operations, and corporate cab services ensure employees reach workplaces safely and on time."
    },
    {
      "WhyChooseheading": "Daily Pickup and Drop for Factory Employees",
      "WhyChoosedescription": "Corporate cab services provide organized daily pickup and drop with optimized routes, reducing commute stress and improving punctuality for industrial workers. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Flexible Shift-Based Transportation Solutions",
      "WhyChoosedescription": "Industrial businesses operate in multiple shifts, and corporate cab services offer flexible scheduling and route planning to support day, night, and rotational workforce movements. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Workforce and Management Travel",
      "WhyChoosedescription": "We provide hatchbacks, sedans, SUVs, and larger vehicles suitable for both factory employees and management-level travel requirements."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs and Safety Protocols",
      "WhyChoosedescription": "Drivers are trained with safety standards and corporate etiquette, ensuring secure and reliable travel for employees working in industrial zones. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Cost-Effective Corporate Transport Solutions",
      "WhyChoosedescription": "Corporate cab services help businesses reduce travel costs with optimized routing, shared commute options, and predictable pricing models. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "24/7 Support for Industrial Operations",
      "WhyChoosedescription": "Round-the-clock support ensures smooth coordination for shift-based transport, emergency travel needs, and uninterrupted factory operations."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Delhi for industrial areas?',
            answer: 'Corporate cab services for industrial areas provide organized transportation for factory employees, staff, and management including daily commute and shift-based travel.',
        },
        {
            question: 'Why are corporate cab services important for industries in Delhi?',
            answer: 'They ensure timely employee arrival, reduce commute stress, and improve productivity in industrial operations. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop for factory workers?',
            answer: 'Yes, services include structured daily pickup and drop with optimized routes and schedules. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Can transportation be arranged for multiple shifts?',
            answer: 'Yes, corporate cab services support day, night, and rotational shifts with flexible route planning. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'What types of vehicles are available for industrial transport?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and larger transport vehicles depending on workforce size and travel needs.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols to ensure secure transportation. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Can companies get monthly contracts for employee transport?',
            answer: 'Yes, companies can opt for monthly and long-term corporate transport contracts for cost-effective commuting.',
        },
        {
            question: 'Do corporate cab services reduce operational costs?',
            answer: 'Yes, optimized routes and shared transport models help reduce overall transportation expenses. :contentReference[oaicite:8]{index=8}',
        },
        {
            question: 'Are services available 24/7 for industrial operations?',
            answer: 'Yes, corporate cab services operate round the clock to support industrial shifts and business requirements.',
        },
        {
            question: 'How can I book corporate cab services in Delhi for industrial use?',
            answer: 'You can book through the service provider’s website or contact their support team for customized industrial transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Kumar',
        designation: 'Plant Manager, Manufacturing Unit, Delhi',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has streamlined our employee transport in Delhi industrial areas. Their punctual service and route management are perfect for factory operations.”',
    },
    {
        name: 'Ms. Neha Verma',
        designation: 'HR Manager, Industrial Company, Delhi',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for workforce transportation. Their flexible plans and reliable service ensure smooth daily commuting for our employees.”',
    },
];



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Delhi for Industrial Use",
  "image": "https://www.etravo.in/images/keyword/industrial-corporate-cab-delhi.jpg",
  "description": "Reliable corporate cab services for industrial use in Delhi by eTravo. Ideal for factory employee transport, industrial area commute, workforce mobility, and corporate travel with safe and efficient service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-delhi-for-industrial"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Cab Services in Delhi for Industrial Use | Factory & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Delhi for industrial use with eTravo. Ideal for factory employee transport, industrial commute, workforce mobility, and corporate travel needs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/149.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceindelhiforindutrial;